<template>
  <div class="grid-view">
    <div class="main-content">
      <bank-slip-query
        ref="bankSlipQuery"
        identify="bankSlipRegister"
        view-source="bankSlipRegister"
        config-module="1200"
        :is-register="true"
        :page-mode="0"
        :check-role="false"
        :ar-field="'ar'"
        :rate-field="'rate'"
        :total-type="'revenueAbs'"
        grid-config-module="1200001"
      >
        <div slot="operations">
          <!--新增-->
          <el-button v-show="$checkPermission(['button_fmBankSlip_bankSlipRegister'])" type="primary" @click="addBtnClickHandler">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
          <!--修改-->
          <el-button v-show="$checkPermission(['button_fmBankSlip_bankSlipRegister'])" type="primary" @click="modifyBtnClickHandler">{{ $t('CargoMsg.Cargo_Modify') }}</el-button>
          <!--删除-->
          <el-button v-show="$checkPermission(['button_fmBankSlip_bankSlipRegister'])" type="danger" @click="delBtnClickHandler">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
          <!--发布-->
          <el-button v-show="$checkPermission(['button_fmBankSlip_bankSlipRegister'])" type="primary" @click="releaseBtnClickHandler">{{ $t('CargoMsg.Cargo_Publish') }}</el-button>
          <!--取消发布-->
          <el-button v-show="$checkPermission(['button_fmBankSlip_bankSlipRegister'])" type="primary" @click="cancelReleaseBtnClickHandler">{{ $t('CargoMsg.Cargo_CancelPublishment') }}</el-button>
          <!--下载导入模版-->
          <el-button v-show="$checkPermission(['button_fmBankSlip_bankSlipRegister'])" type="primary" @click="downloadImportTemplate">{{ $t('CargoMsg.Cargo_DownloadImportTemplate') }}</el-button>
          <!--导入水单-->
          <div v-show="$checkPermission(['button_fmBankSlip_bankSlipRegister'])" style="display: inline-block; margin-left: 5px">
            <el-upload
              :action="URL.act.actualAmount.importActualAmountUrl"
              :headers="{sessionId:$store.getters.userInfo.sessionId}"
              :data="{branchId :$store.getters.currentOfficeId}"
              :show-file-list="false"
              accept=".xlsx"
              :before-upload="beforeUpload"
              :on-success="uploadSuccess"
            >
              <el-button type="primary">{{ $t('CargoMsg.Cargo_ImportBankSlip') }}</el-button>
            </el-upload>
          </div>
        </div>
        <template v-slot:searchAreaHeader />
      </bank-slip-query>
    </div>
    <bank-slip-window
      :visible.sync="bankSlipWindow.visible"
      :pre-payment="bankSlipWindow.prePayment"
      :params="bankSlipWindow.params"
      :show-publish="bankSlipWindow.showPublish"
      :ar="true"
      @refresh="refreshPageHandler"
    />
  </div>
</template>

<script>

import BankSlipQuery from '@/views/cargo/v0/Clearing/components/bankSlip/bankSlipQuery'
import { cacheName, cache } from '@/utils/cacheManager'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { DocumentManage } from '@/utils/commonUtil'
import {
  BANK_SLIP_RELEASE_STATES,
  BANK_SLIP_RETURN_STATES,
  BANK_SLIP_UNRELEASE_STATES,
  BANK_SLIP_UNSTATES
} from '@/class/cargo/model/parameters/ClearingConstants'
import BankSlipWindow from '@/views/cargo/v0/Clearing/components/bankSlip/bankSlipWindow'
import * as actualAmountApi from '@/api/clearing/actualAmount'
import * as writeoffApi from '@/api/act/writeoff'
import { deleteActualAmountFunc, updateActualReleaseStateFunc } from '@/api/clearing/actualAmount'
import { getLoading } from '@/utils/utilBaseElement'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import URL from '@/api/urlTranslator'

export default {
  name: 'BankSlipRegister',
  components: {
    BankSlipQuery,
    BankSlipWindow,
    searchItem
  },
  data() {
    return {
      documentManage: new DocumentManage(),
      selectedData: null,
      selectedDataList: [],
      gridApi: null,
      bankSlipWindow: {
        visible: false,
        prePayment: false,
        showPublish: true,
        params: null
      },
      URL
    }
  },
  computed: {

  },
  async created() {
    await this.preloadBasicData()
    await cache.load(cacheName.OFFICE, cacheName.CONFIG)
    this.office = cache.office
  },
  beforeMount() {

  },
  beforeDestroy() {

  },
  methods: {
    // 初始化配置参数
    async preloadBasicData() {
      await cache.load(cacheName.CONFIG)
    },
    onGridReady(p) {
      this.gridApi = p.api
    },
    // 分页查询
    refreshPageHandler() {
      this.$refs.bankSlipQuery.refreshPageHandler()
    },
    // 新增
    addBtnClickHandler() {
      const params = {}
      params.branchId = this.$store.getters.currentOfficeId
      const localCurrency = RateUtil.localCurrencyByOffice()
      params.currency = localCurrency
      params.payReceiveDate = new Date()
      this.bankSlipWindow.params = params
      this.bankSlipWindow.visible = true
    },
    // 修改
    modifyBtnClickHandler() {
      this.selectedData = this.$refs.bankSlipQuery.selectedData
      if (!this.selectedData || !this.selectedData.uuid) {
        this.$message.warning(this.$t('Clearing.PleaseAWaterBillRecord'))
        return
      }
      if (this.selectedData.releaseState !== BANK_SLIP_UNRELEASE_STATES.code) {
        this.$message.warning(this.$t('Clearing.WaterReleasedAndCannotModified'))
        return
      }
      if (this.selectedData.bankSlipState !== BANK_SLIP_UNSTATES.code) {
        this.$message.warning(this.$t('Clearing.WaterClaimedAndCannotModified'))
        return
      }
      if (this.selectedData.bankSlipState === BANK_SLIP_RETURN_STATES.code) {
        this.$message.warning(this.$t('Clearing.WaterReturnedAndCannotModified'))
        return
      }
      this.loading = getLoading()
      this.filterJson = {}
      this.filterJson.conditions = []
      this.filterJson.conditions.push(new AdvancedSearchOption(null, 'actualAmount.UUID', this.selectedData.uuid, AdvancedSearchConsts.OPERATOR_EQUAL.code))
      this.filterJson.pageNum = 1
      this.filterJson.pageSize = 1
      writeoffApi.queryActualAmountPageable(this.filterJson).then(res => {
        this.loading.close()
        if (res && res.data && res.data.list.length > 0) {
          this.bankSlipWindow.title = this.$t('CargoMsg.Cargo_BankReceiptRecord')
          this.bankSlipWindow.isPrePayment = false
          this.bankSlipWindow.params = res.data.list[0]
          this.bankSlipWindow.visible = true
        }
      }).catch((err) => {
        this.$message.error(err)
        this.loading.close()
      })
    },
    // 删除
    async delBtnClickHandler() {
      this.selectedData = this.$refs.bankSlipQuery.selectedData
      if (!this.selectedData || !this.selectedData.uuid) {
        this.$message.warning(this.$t('Clearing.PleaseAWaterBillRecord'))
        return
      }
      if (this.selectedData.releaseState !== BANK_SLIP_UNRELEASE_STATES.code) {
        this.$message.warning(this.$t('Clearing.WaterReleasedAndCannotModified'))
        return
      }
      if (this.selectedData.bankSlipState !== BANK_SLIP_UNSTATES.code) {
        this.$message.warning(this.$t('Clearing.WaterClaimedAndCannotModified'))
        return
      }
      // 检查是否有核销记录
      await actualAmountApi.getClearHistory({ actualAmountUuid: this.selectedData.uuid }).then(resp => {
        const clearHistory = resp.data
        if (clearHistory && clearHistory.length > 0) {
          this.$message.warning(this.$t('Clearing.WaterRecordsAndCannotVoided'))
          return
        }
        // 检查是否导出过接口
        this.checkExportedToVoucherHandler(this.selectedData)
      }).catch((err) => {
        this.$message.error(err)
        this.loading.close()
      })
    },
    // 检查是否导出凭证
    checkExportedToVoucherHandler(actualAmount) {
      writeoffApi.checkExportedToVoucher({ actualAmountUuid: actualAmount.uuid }).then(resp => {
        const exist = event.data
        if (exist) {
          this.$message.warning(this.$t('Clearing.WaterToFinancialVoucherVoided'))
          return
        }
        this.$confirm(this.$t('CargoMsg.Cargo_SureToDelete'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('Clearing.Confirm'),
          cancelButtonText: this.$t('Clearing.Cancel'),
          type: 'warning'
        }).then(() => {
          deleteActualAmountFunc([actualAmount.uuid]).then(resp => {
            this.refreshPageHandler()
            this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
          }).catch((err) => {
            this.$message.error(err)
            this.loading.close()
          })
        })
      }).catch((err) => {
        this.$message.error(err)
        this.loading.close()
      })
    },
    // 发布
    releaseBtnClickHandler() {
      this.selectedDataList = this.$refs.bankSlipQuery.selectedDataList
      if (this.selectedDataList === null || this.selectedDataList.length === 0) {
        this.$message.warning(this.$t('Clearing.PleaseAWaterBillRecord'))
        return
      }
      const releaseList = []
      for (const act of this.selectedDataList) {
        if (act.releaseState === BANK_SLIP_UNRELEASE_STATES.code) {
          act.releaseState = BANK_SLIP_RELEASE_STATES.code
          releaseList.push(act.uuid)
        }
      }
      if (releaseList.length === 0) {
        this.$message.warning(this.$t('Clearing.NoBillRecordsToRelease'))
        return
      }
      updateActualReleaseStateFunc(releaseList, BANK_SLIP_RELEASE_STATES.code).then(res => {
        this.refreshPageHandler()
      }).catch((err) => {
        this.$message.error(err)
      })
    },
    // 取消发布
    cancelReleaseBtnClickHandler() {
      this.selectedDataList = this.$refs.bankSlipQuery.selectedDataList
      if (this.selectedDataList === null || this.selectedDataList.length === 0) {
        this.$message.warning(this.$t('Clearing.PleaseAWaterBillRecord'))
        return
      }
      const releaseList = []
      for (const act of this.selectedDataList) {
        if (act.releaseState === BANK_SLIP_RELEASE_STATES.code && act.bankSlipState === BANK_SLIP_UNSTATES.code) {
          act.releaseState = BANK_SLIP_UNRELEASE_STATES.code
          releaseList.push(act.uuid)
        }
      }
      if (releaseList.length === 0) {
        this.$message.warning(this.$t('Clearing.NoRecordsToCancelRelease'))
        return
      }
      updateActualReleaseStateFunc(releaseList, BANK_SLIP_UNRELEASE_STATES.code).then(res => {
        this.refreshPageHandler()
      }).catch((err) => {
        this.$message.error(err)
      })
    },
    downloadImportTemplate() {
      ExportUtils.downloadTemplateFile('ImportWaterBill.xlsx', 'act')
    },
    beforeUpload(file) {
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xlsx'
      if (!extension) {
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsx'))
      } else {
        return true
      }
    },
    uploadSuccess(response, file, fileList) {
      if (response && response.data) {
        if (response.data.result === true) {
          this.$message.success(response.data.message)
          // 刷新查询
          this.refreshPageHandler()
        } else {
          if (Array.isArray(response.data.message)) {
            // 将数组的元素使用\n拼接到一起
            const errorMsg = response.data.message.join('\n')
            this.$message({
              message: '<div style="white-space: pre-line;">' + errorMsg + '</div>',
              dangerouslyUseHTMLString: true,
              type: 'error'
            })
          } else {
            this.$message.error(response.data.message)
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
#app #verify-tree-grid {
  .ag-theme-balham {
    .ag-row-hover {
      background: #9bddff !important;
    }
    .ag-row-focus {
      background: #6abdff !important;
    }
  }
  .main-inner-row {
    display: flex;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .query-input-spacing {
    padding-right: 10px;
  }
}
</style>
